module.exports = __webpack_public_path__ + "img/40_38_072_760.1d4be5a9.jpg";